import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import BurnCharts from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/burndown_chart/components/burn_charts.vue?vue3';

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

export default () => {
  // generate burndown chart (if data available)
  const container = '.burndown-chart';
  const chartEl = document.querySelector(container);

  if (chartEl) {
    const { startDate, dueDate, milestoneId, burndownEventsPath } = chartEl.dataset;
    const isLegacy = parseBoolean(chartEl.dataset.isLegacy);

    initVueApp({
      el: container,
      name: 'BurnChartsRoot',
      component: BurnCharts,
      apolloProvider,
      props: {
        showNewOldBurndownToggle: isLegacy,
        burndownEventsPath,
        startDate,
        dueDate,
        milestoneId,
      },
    });
  }
};
